import { IconProps } from '../../icons/types';

const MapLocationIcon = (props: IconProps) => {
  const { height = 16, width = 16, fillColor = 'var(--light-grayscale-content-2)' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
    >
      <mask
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="var(--lightgray-base)" />
      </mask>
      <g mask="url(#mask0_6755_78536)">
        <path
          d="M7.99984 8C8.3665 8 8.6805 7.86933 8.94184 7.608C9.20273 7.34711 9.33317 7.03333 9.33317 6.66666C9.33317 6.29999 9.20273 5.98599 8.94184 5.72466C8.6805 5.46377 8.3665 5.33333 7.99984 5.33333C7.63317 5.33333 7.31939 5.46377 7.0585 5.72466C6.79717 5.98599 6.6665 6.29999 6.6665 6.66666C6.6665 7.03333 6.79717 7.34711 7.0585 7.608C7.31939 7.86933 7.63317 8 7.99984 8ZM7.99984 14.4167C7.91095 14.4167 7.82206 14.4 7.73317 14.3667C7.64428 14.3333 7.5665 14.2889 7.49984 14.2333C5.87761 12.8 4.6665 11.4696 3.8665 10.242C3.0665 9.014 2.6665 7.86666 2.6665 6.79999C2.6665 5.13333 3.20273 3.80555 4.27517 2.81666C5.34717 1.82777 6.58873 1.33333 7.99984 1.33333C9.41095 1.33333 10.6525 1.82777 11.7245 2.81666C12.7969 3.80555 13.3332 5.13333 13.3332 6.79999C13.3332 7.86666 12.9332 9.014 12.1332 10.242C11.3332 11.4696 10.1221 12.8 8.49984 14.2333C8.43317 14.2889 8.35539 14.3333 8.2665 14.3667C8.17761 14.4 8.08873 14.4167 7.99984 14.4167Z"
          fill={fillColor}
        />
      </g>
    </svg>
  );
};

export default MapLocationIcon;
